import {initApp as initPlayer } from "./app";
import {formatDateTimes, formatTimeTo} from "../../shared/time-formating";

window.players = {};

function handleShowDescription(this: HTMLLabelElement){
    if (!this.parentElement){
        return
    }
    const elAnchor = document.createElement('a');
    elAnchor.setAttribute('href', "#");
    elAnchor.setAttribute('class', this.getAttribute("class") || "")
    elAnchor.appendChild(document.createTextNode('Less'));
    elAnchor.addEventListener('click', function (this: HTMLAnchorElement, ev){
        ev.preventDefault();
        if (this.parentElement){
            const checkbox: HTMLInputElement|null = this.parentElement.querySelector<HTMLInputElement>('[type="checkbox"]')
            if (checkbox){
                checkbox.checked = false;
            }
        }
        this.innerText = "Less"
        this.remove();
    })
    this.parentElement.appendChild(elAnchor)
}

function initObservers() {
    const ps = document.querySelectorAll('.expandable');
    const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
            entry.target.classList[Math.round(entry.target.scrollHeight) > Math.round(entry.contentRect.height) ? 'add' : 'remove']('truncated');
        }
    });

    ps.forEach(p => {
        observer.observe(p);
    });

    document.querySelectorAll<HTMLLabelElement>('label[for="expanded"]').forEach((entry: HTMLLabelElement) => {
        entry.addEventListener('click', handleShowDescription)
    })
}

export const initApp = () => {
    initObservers();
    formatDateTimes();
    formatTimeTo();

    initPlayer();
}
// import(
//     /* webpackChunkName: "triller-pb" */
//     /* webpackFetchPriority: "high" */
//     /* webpackPreload: true */ './app')
//     .then((module) => {
//         module.initApp();
//     })
